// The sourced numbers on the landing page (story #24, variant A). Every tile
// names its source on the page, and evidence.test.js pins each `check` string
// to the row `tag` in docs/research/2026-09-17-solo-founders-and-pitching.md,
// so a number that is not in the record's source table cannot ship
// (product-invariants section 4). Edit the record first, then this file.
export const EVIDENCE_RECORD = 'docs/research/2026-09-17-solo-founders-and-pitching.md';

export const problem = {
  heading: 'Building got cheap. Being heard did not.',
  sub: 'A record number of people are starting something, more of them alone than ever, and the thing they say is hardest is not the product.',
  tiles: [
    { n: '5.67M', line: 'new US business applications in 2025, more than double 2010', source: 'US Census Bureau, Business Formation Statistics', tag: 'S1', check: ['5,671,836 (2025)', '2,473,934 (2010)'] },
    { n: '35%', line: 'of new startups on Carta in 2024 had one founder, up from 17% in 2017', source: 'Carta, Founder Ownership Report 2025', tag: 'S21', check: ['35 percent (2024)', '17 percent (2017)'] },
    { n: '32%', line: 'of 2,000 startup builders call customer acquisition their biggest challenge; 40% when AI writes most of the code', source: 'Supabase, State of Startups 2026', tag: 'S31', check: ['Customer acquisition 32', '40 percent among', '2,000 startup builders'] },
  ],
};

export const odds = {
  heading: 'Getting in front of them is what moves the odds.',
  tiles: [
    { n: 'More revenue', line: 'for founders trained to test their idea with customers, in a randomized trial of 116 startups; across 759 firms in four trials the same training made founders drop weak ideas sooner', source: 'Camuffo, Gambardella et al., Management Science 2020; Strategic Management Journal 2024', tag: 'S34', check: ['116 startups', '759 firms', 'Randomized', 'terminate weak ideas'] },
    { n: '52%', line: 'of 2,058 B2B buyers say the product demo is the resource they consult most before buying', source: 'TrustRadius, Bridging the Trust Gap, 2025', tag: 'S43', check: ['52 percent of all buyers', '2,058'] },
    { n: '51%', line: 'of 980 B2B marketers say webinars produce their best results, second only to in-person events at 52%', source: 'Content Marketing Institute, B2B Content Marketing Benchmarks 2025', tag: 'S41', check: ['webinars 51 percent', 'In-person events 52 percent', '980'] },
  ],
  facts: [
    { n: '51%', line: 'of registrants show up to a webinar, and they stay 26 minutes', source: 'Livestorm, 33,786 sessions in 2025', tag: 'S36', check: ['51.3 percent show-up', '33,786 sessions', '26 minutes'] },
    { n: 'More confident', line: 'is how blind raters scored speakers who practised a real talk in front of a supportive audience, in the one randomized study that measured it', source: 'Kroczek and Muehlberger, Scientific Reports 2023', tag: 'S50', check: ['d = 0.84', '73 students randomized', 'supportive audience'] },
  ],
  turn: 'Those thirty minutes are the pitch. The delivery is the part founders underestimate: the room remembers how you presented more than what was on the slides.',
  toolsLead: 'Practice is what makes it. Fullrun is the tools for that practice.',
  tools: [
    { title: 'The script beside the slides', line: 'One file builds the window you share and the window only you see.' },
    { title: 'The demo filmed on the real product', line: 'Never live on wifi, never on a stale account.' },
    { title: 'Camera on, clock running', line: 'Framing guides, a pace meter, a target per slide.' },
    { title: 'A review that rewrites the script', line: 'Every run measured; the script revised from what you actually said.' },
  ],
};

// Three series where every point is in the record (a chart earns its place only then).
export const series = {
  applications: {
    title: 'New US business applications, per year',
    source: 'US Census Bureau, Business Formation Statistics, monthly series summed by calendar year',
    tag: 'S1',
    unit: 'M',
    points: [[2010, 2473934], [2011, 2550495], [2012, 2550198], [2013, 2591539], [2014, 2691040], [2015, 2795897], [2016, 2948338], [2017, 3182674], [2018, 3486829], [2019, 3498990], [2020, 4356498], [2021, 5390816], [2022, 5062563], [2023, 5469302], [2024, 5224176], [2025, 5671836]],
    check: (y, v) => `| ${y} | ${v.toLocaleString('en-US')} |`,
  },
  solo: {
    title: 'New startups on Carta with one founder',
    source: 'Carta, Founder Ownership Report 2025',
    tag: 'S21',
    unit: '%',
    points: [[2017, 17], [2023, 29], [2024, 35]],
    check: (y, v) => `${v} percent (${y})`,
  },
  survival: {
    title: 'Businesses still open, by years since opening',
    source: 'US Bureau of Labor Statistics, Business Employment Dynamics, establishments born in March, through March 2025',
    tag: 'S9',
    unit: '%',
    points: [[1, 77.9], [2, 65.9], [3, 56.3], [5, 51.4], [6, 46.8], [10, 34.7], [15, 25.5]],
    check: (y, v) => (y === 1 ? `${v} percent at 1 year` : `${v} at ${y}`),   // the row reads "77.9 percent at 1 year ...; 65.9 at 2 ..."
  },
};
